<template>
    <div class="PmsOrder">
        <main class="content">
            <el-card>
                <el-button type="primary" @click="handleRefreshToken()" size="mini" :loading="loading">更新Token</el-button>
                <el-button type="primary" @click="handleRefreshCategory()" size="mini" :loading="loading">更新商品分类</el-button>
                <el-button type="primary" @click="handleRefreshBrand()" size="mini" :loading="loading">更新商品品牌</el-button>
                <el-button type="primary" @click="handleRefreshSaleUnit()" size="mini" :loading="loading">更新商品分类销售单位</el-button>
            </el-card>
        </main>
    </div>
</template>
<script>
export default {

    data() {
        return {
            loading: false
        };
    },
    methods: {
        handleRefreshToken() {
            const that = this;
            this.loading = true;
            this.$confirm('此操作将更新福田商城接口Token，非管理员请勿操作！！！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.get('/admin/tool/jcy/refreshToken'
                ).then(function () {
                // }).finally(() => {
                //     that.loading = false;
                });
            }).finally(() => {
                that.loading = false;
            });
        },
        handleRefreshCategory() {
            const that = this;
            this.loading = true;
            this.$confirm('此操作将更新福田商品分类，非管理员请勿操作！！！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.get('/admin/tool/jcy/refreshCategory'
                ).then(function () {
                }).finally(() => {
                    that.loading = false;
                });
            }).finally(() => {
                that.loading = false;
            });
        },
        handleRefreshBrand() {
            const that = this;
            this.loading = true;
            this.$confirm('此操作将更新福田商品品牌，非管理员请勿操作！！！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.get('/admin/tool/jcy/refreshBrand'
                ).then(function () {
                }).finally(() => {
                    that.loading = false;
                });
            }).finally(() => {
                that.loading = false;
            });
        },
        handleRefreshSaleUnit() {
            const that = this;
            this.loading = true;
            this.$confirm('此操作将更新福田商品销售单位，非管理员请勿操作！！！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.get('/admin/tool/jcy/refreshSaleUnit'
                ).then(function () {
                }).finally(() => {
                    that.loading = false;
                });
            }).finally(() => {
                that.loading = false;
            });
        },
    },
}
</script>
<style>
</style>
